import ParseFunctions from '@/components/ParseFunctions'
import Parse from 'parse'

const runParseFunction = ParseFunctions.methods

const actions = {
  reloadTeams({ commit }) {
    runParseFunction.getTeams().then(e => {
      if (e.status === 'ok') {
        commit('setTeams', e.teams)
      }
    })
  },
  reloadUserSettings({ commit, state }, payload) {
    if (!payload) {
      runParseFunction.userSettingsCLAPI().then(e => {
        if (e.status !== 'ok') return
        e = e.settings
        commit('setUserSettings', e)
        commit('setUserStartOfWeek', e['week-start'])
        if (state.userSettings['is-24h'] === undefined) {
          const moment = require('moment-timezone')
          let timezone = state.userSettings['timezone'] || moment.tz.guess()
          let countryCode = state.timezonesGlobal.find(x => x.value === timezone).countryCode
          let hourFormat = moment()
            .locale(countryCode)
            .format('LT')

          let lastChar = hourFormat.charAt(hourFormat.length - 1)

          let res = runParseFunction.setUserSetting('is-24h', lastChar.toUpperCase() !== 'M')
          if (res.status === 'ok') {
            commit('setOneUserSetting', { name: 'is-24h', value: lastChar.toUpperCase() !== 'M' })
          }
        }
      })
    } else {
      if (payload.name === 'week-start') {
        commit('setUserStartOfWeek', payload.value)
      }
      commit('setOneUserSetting', payload)
    }
  },
}

export default actions
